var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feed"},[_c('div',{staticClass:"container"},[_c('Navbar'),_c('FiltersPlayers'),_c('Footer')],1),_c('Notification',{attrs:{"parentList":_vm.list,"user":_vm.user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }